

































































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import PluginApply from "./plugin_apply.vue";

import PluginUpdate from "./plugin_update.vue";

@Component({
  components: {
    PluginApply,
    PluginUpdate
  }
})
export default class extends Mixins(MyList) {
  @Prop() appid!: string;

  pluginAppid = "";

  applyModalVisible = false;

  updateModalVisible = false;

  columns: any[] = [
    { title: "插件appid", dataIndex: "appid" },
    { title: "插件申请状态", scopedSlots: { customRender: "status" } },
    { title: "插件昵称", dataIndex: "nickname" },
    { title: "插件头像", scopedSlots: { customRender: "headimgurl" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showApplyModal() {
    this.applyModalVisible = true;
  }

  hideApplyModal() {
    this.applyModalVisible = false;
    this.loadPlugins();
  }

  showUpdateModal(pluginAppid: string) {
    this.pluginAppid = pluginAppid;
    this.updateModalVisible = true;
  }

  hideUpdateModal() {
    this.updateModalVisible = false;
  }

  mounted() {
    this.loadPlugins();
  }

  async loadPlugins() {
    this.loading = true;
    const res = await this.$store.dispatch("oplatformapps/plugin", {
      appid: this.appid,
      action: "list"
    });
    if (res && res.Data) {
      this.data = res.Data;
    }
    this.loading = false;
  }

  handleDelete1() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要删除该插件吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("oplatformapps/plugin", {
          appid: this.appid,
          action: "unbind"
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadPlugins();
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }
}
